const EXPIRY_TYPE = {
  DOES_NOT_EXPIRE: "DOES_NOT_EXPIRE",
  EXPIRY_DATE: "EXPIRY_DATE",
  ISSUE_PLUS_VALIDITY: "ISSUE_PLUS_VALIDITY",
} as const;

const MAPPING_LEVELS = {
  LOCATION: "LOCATION",
  GLOBAL: "GLOBAL",
  STATE: "STATE",
  COUNTY: "COUNTY",
  MSA: "MSA",
  HCF: "HCF",
} as const;

const DRIVING_LICENSE_STATE_ID_REQUIREMENT_ID = "5b932fcb38aeaa0014c3688f";

export { DRIVING_LICENSE_STATE_ID_REQUIREMENT_ID, EXPIRY_TYPE, MAPPING_LEVELS };

export {
  CLIPBOARD_HEALTH,
  WORKER_AND_WORKPLACE_DATA_STALE_TIME_IN_MS,
} from "@src/appV2/redesign/RequiredDocuments/constants";
